import { lazy } from 'react';
import { PermissionsGuard } from './components';
import {
    CREATE_PERMISSION,
    FINANCIAL_INSTITUTIONS_AUTH,
    READ_PERMISSION,
    UPDATE_PERMISSION,
} from 'src/constants/permissions';

export const Routes = [
    {
        exact: true,
        path: '/create/financialInstitution',
        guard: PermissionsGuard,
        roles: {
            permission: FINANCIAL_INSTITUTIONS_AUTH,
            crud: CREATE_PERMISSION,
        },
        component: lazy(
            () =>
                import(
                    'src/views/financialInstitution/FinancialInstitutionCreateView'
                )
        ),
    },
    {
        exact: true,
        path: '/management/financialInstitutions/:id',
        guard: PermissionsGuard,
        roles: {
            permission: FINANCIAL_INSTITUTIONS_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(
            () =>
                import(
                    'src/views/financialInstitution/FinancialInstitutionDetailsView'
                )
        ),
    },
    {
        exact: true,
        path: '/management/financialInstitutions/:id/edit',
        guard: PermissionsGuard,
        roles: {
            permission: FINANCIAL_INSTITUTIONS_AUTH,
            crud: UPDATE_PERMISSION,
        },
        component: lazy(
            () =>
                import(
                    'src/views/financialInstitution/FinancialInstitutionEditView'
                )
        ),
    },
    {
        exact: true,
        path: '/management/financialInstitutions',
        guard: PermissionsGuard,
        roles: {
            permission: FINANCIAL_INSTITUTIONS_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(
            () =>
                import(
                    'src/views/financialInstitution/FinancialInstitutionListView'
                )
        ),
    },
];
